module.exports = __webpack_public_path__ + "media/images/gifts/light/sug_luz_9-76b5f1a5a2a238119720ce5fb85677ff.jpg";